/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../usermessagetype.ts" />
/// <reference path="app.common.services.module.ts" />
/// <reference path="../iresultwithmessages.d.ts" />

module App.Common.Services {
	'use strict';

	export class UserMessagesService {

		public static $inject = ['$document', '$timeout'];

		constructor(private $document: duScroll.IDocumentService, private $timeout: angular.ITimeoutService) {}

		public messages = {
			successMessages: [] as string[],
			errorMessages: [] as string[],
			warningMessages: [] as string[],
			informationMessages: [] as string[],
			variationMessages: [] as string[]
		} as Hca.HiLO.Model.IUserMessages;

		public deferredMessages = {
			successMessages: [] as string[],
			errorMessages: [] as string[],
			warningMessages: [] as string[],
			informationMessages: [] as string[],
			variationMessages: [] as string[]
		} as Hca.HiLO.Model.IUserMessages;

		public addMessages(messages: Hca.HiLO.Model.IUserMessages, defer: boolean = false) {

			if (!messages) {
				throw new Error('messages not defined');
			}

			const collection = defer ? this.deferredMessages : this.messages;

			collection.successMessages = collection.successMessages.concat(messages.successMessages || []);
			collection.errorMessages = collection.errorMessages.concat(messages.errorMessages || []);
			collection.warningMessages = collection.warningMessages.concat(messages.warningMessages || []);
			collection.informationMessages = collection.informationMessages.concat(messages.informationMessages || []);

			if (!defer && this.messageCount(messages)) {
				this.scrollMessagesIntoView();
			}
		}

		public addMessage(message: string, type: UserMessageType, defer: boolean = false) {

			if (!message) {
				throw new Error('message not defined');
			}

			const collection = defer ? this.deferredMessages : this.messages;

			switch (type) {
				case UserMessageType.Success:
					collection.successMessages.push(message);
					break;
				case UserMessageType.Error:
					collection.errorMessages.push(message);
					break;
				case UserMessageType.Warning:
					collection.warningMessages.push(message);
					break;
				case UserMessageType.Information:
					collection.informationMessages.push(message);
					break;
				default:
					collection.informationMessages.push(message);
					break;
			}

			if (!defer) {
				this.scrollMessagesIntoView();
			}
		}

		private messageCount(messages: Hca.HiLO.Model.IUserMessages) {
			if (!messages) {
				return 0;
			}
			return _(messages)
				.keys()
				.sumBy((key: string): number => {
					return _(key).endsWith('Messages') ? messages[key].length : 0;
				});
		}

		public scrollMessagesIntoView() {
			const el = angular.element('user-messages');
			if (!el.length) {
				return;
			}
			this.$document.duScrollToElementAnimated(el);
		}

		public clear() {
			this.messages.successMessages.length = 0;
			this.messages.errorMessages.length = 0;
			this.messages.warningMessages.length = 0;
			this.messages.informationMessages.length = 0;
		}

		public clearDeferred() {
			this.deferredMessages.successMessages.length = 0;
			this.deferredMessages.errorMessages.length = 0;
			this.deferredMessages.warningMessages.length = 0;
			this.deferredMessages.informationMessages.length = 0;
		}

		public collectDeferredMessages() {
			this.clear();
			this.addMessages(this.deferredMessages);
			this.clearDeferred();
		}

	}

	angular
		.module('app.common.services')
		.service('app.common.services.userMessagesService', UserMessagesService);
}